// extracted by mini-css-extract-plugin
export var container = "index-module--container--5oUVH";
export var h2 = "index-module--h2--Jce-n";